import fetch from "core/fetch";

import {Manifest} from '../model';

const fetchManifests = (query, page, size) => fetch.doGet(process.env.REACT_APP_API_URL, {query, page, size}, Manifest.fromServerList);

export default {
    fetchManifests,
};
